import classes from 'components/common/ConfirmDeleteModal/ConfirmDeleteModal.module.scss';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';

interface Props {
    open: boolean;
    onClose: () => void;
    action: () => void;
    isLoading: boolean;
    title: string;
    children: React.ReactNode;
}

export const ConfirmDeleteModal = ({ open, onClose, action, isLoading, title, children }: Props) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            title={title}
            actions={
                <>
                    <Button size={'medium'} variant={'secondary'} onClick={onClose}>
                        Cancel
                    </Button>

                    <Button
                        size={'medium'}
                        variant={'primary'}
                        onClick={action}
                        isLoading={isLoading}
                        disabled={isLoading}
                        destructive
                    >
                        Remove
                    </Button>
                </>
            }
        >
            <div className={classes.deleteMessage}>
                <MuiIcon icon={'warning'} color={'var(--button-primary-bg_destructive)'} fontSize={'30px'} />
                <span className={classes.title}>{children}</span>
            </div>
        </Modal>
    );
};
